import { DashboardWidgetType } from '../types';

type Returns = { type: DashboardWidgetType; label: string }[];

export const getDashboardWidgetOptions = (): Returns => {
  return [
    { type: DashboardWidgetType.PROFILE, label: 'Profile' },
    { type: DashboardWidgetType.CONTACTS, label: 'Contacts' },
    { type: DashboardWidgetType.STICKY_NOTE, label: 'Sticky Notes' },
    { type: DashboardWidgetType.CHECKLISTS, label: 'Checklists' },
    { type: DashboardWidgetType.GOAL_LIST, label: 'Goal List' },
    { type: DashboardWidgetType.GOAL_CAROUSEL, label: 'Goal Carousel' },
    { type: DashboardWidgetType.NEXT_EVENT, label: 'Next Event' },
    { type: DashboardWidgetType.TODAY_SCHEDULE, label: 'Todays Schedule' },
    { type: DashboardWidgetType.TIMER, label: 'Timer' },
    { type: DashboardWidgetType.IMAGE, label: 'Image' },
    { type: DashboardWidgetType.APP, label: 'Application Thumbnail' },
    { type: DashboardWidgetType.PHONE, label: 'Phone' },
    { type: DashboardWidgetType.CAMERA, label: 'Camera' },
  ];
};
